export class ZoneInfo {
    name: string
    accountHash: string
    servicePatchUrl: string
}
